export const selectIsAuthenticated = (state) => state.auth.isAuthenticated;
export const selectCurrentUser = (state) => state.auth.user;
export const selectCurrentUserProfile = (state) => state.auth.profileData;
export const selectCurrentUserBillingDetails = (state) =>
  state.auth.billingDetails;
export const selectCurrentUserCards = (state) => state.auth.cards;
export const selectPendingReadNotification = (state) => state.auth.isPendingReadNotification;
export const selectUserPoints = (state) => state.auth.pointLists;
export const selectUserPointsLoading = (state) => state.auth.pointsLoading;
export const selectAuthError = (state) => state.auth.error;
export const selectAuthLoading = (state) => state.auth.loading;
